import React from 'react';

import PropTypes from 'prop-types';

import BaseParameters from '../base/components/BaseParameters';
import {
    createFieldRegistry,
    createCommonFieldMappings,
} from '../base/components/FieldRegistry';

const Parameters = ({ algorithmOptions, control, disabled, setValue }) => {
    const fields = createFieldRegistry({ control, disabled, setValue });
    const fieldsMappingByAlgorithm = createCommonFieldMappings(fields);

    return (
        <BaseParameters
            algorithmOptions={algorithmOptions}
            control={control}
            disabled={disabled}
            fieldsMappingByAlgorithm={fieldsMappingByAlgorithm}
            setValue={setValue}
        />
    );
};

Parameters.propTypes = {
    algorithmOptions: PropTypes.array,
    control: PropTypes.object,
    disabled: PropTypes.bool,
    setValue: PropTypes.func,
};

export default Parameters;
